import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

//components
import { FaFolderOpen } from "react-icons/fa";
import { Spinner, Row } from "react-bootstrap";
import { ListContent } from "../favorites-list/styles"

//services
import { listFavoriteDisciplines } from "../../../../services/favorites.service"
import { CardList } from "../../../../components/card-list";
import { getStorageFavoriteMaterials } from "../../../../utils/storageFavoriteMaterials";
import { IListFavorites } from "../models/IListFavorites";


export const DisciplineFavorites: React.FC<IListFavorites> = ({ removeFavorite, listFilter, isAuth }) => {
  const { t: translation } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [disciplines, setDisciplines] = useState([]);

  useEffect(() => {

    if (isAuth) {
      listFavoriteDisciplines(listFilter).then((resp: any) => {
        setDisciplines(resp.results);
      }).finally(() => {
        setLoading(false);
      })
    } else {
      const favoriteDisciplines = getStorageFavoriteMaterials('@favorites_disciplines')
      if (favoriteDisciplines) { 
        listFilter.favorites = favoriteDisciplines
      }
      setLoading(true)
      listFavoriteDisciplines(listFilter).then((resp: any) => {
        setDisciplines(resp.results);
      }).finally(() => {
        setLoading(false);
      })
    }



  }, [listFilter, isAuth])


  if (loading) {
    return (
      <div className="loading-container mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <Row>
      <ListContent>
        {
          disciplines.length === 0 ? (
            <div className="text-center text-grey mt-5">
              <FaFolderOpen className="mt-5" size={150} />
              <h5>{translation("favorites.emptyDisciplines")}</h5>
            </div>
          ) :
            (
              disciplines.map((discipline: any) => (
                <CardList key={discipline.id} material={discipline} isMaterialView={true} removeFavorite={removeFavorite} />
              ))
            )
        }
      </ListContent>
    </Row>
  )
}